export const DataHooks = {
  Title: 'PaymentMethod.Title',
  PrimaryMark: 'PaymentMethod.PrimaryMark',
  Skeleton: 'PaymentMethod.Skeleton',
} as const;
